import {
    ProfileCompletionConfigDto,
    UpdateRuleParameterRequest,
    UpdateRuleTextRequest,
    UpdateSectionWeightRequest,
} from "../types/profileCompletionAdmin";
import { BackendHttpService } from "./backendHttpService";

export class ProfileCompletionAdminService extends BackendHttpService {
    constructor() {
        super("ProfileCompletionAdmin");
    }

    async getConfig(): Promise<ProfileCompletionConfigDto> {
        return this.get<ProfileCompletionConfigDto>("/config");
    }

    async updateRuleText(
        sectionRuleId: number,
        request: UpdateRuleTextRequest
    ): Promise<void> {
        await this.patch<UpdateRuleTextRequest, void>(
            request,
            `/rule-text/${sectionRuleId}`
        );
    }

    async updateRuleParameter(
        parameterId: number,
        request: UpdateRuleParameterRequest
    ): Promise<void> {
        await this.patch<UpdateRuleParameterRequest, void>(
            request,
            `/rule-parameter/${parameterId}`
        );
    }

    async toggleRuleEnabled(sectionRuleId: number): Promise<boolean> {
        return this.patch<Record<string, never>, boolean>(
            {},
            `/rule/${sectionRuleId}/toggle`
        );
    }

    async updateSectionWeight(
        sectionId: number,
        request: UpdateSectionWeightRequest
    ): Promise<void> {
        await this.patch<UpdateSectionWeightRequest, void>(
            request,
            `/section/${sectionId}/weight`
        );
    }
}

export const profileCompletionAdminService =
    new ProfileCompletionAdminService();
